import React from "react";
import { Map as MapComponent } from "@/shared/Map";

interface DispatchMapPanelProps {
  routes: any[];
  resources: any[];
  onShiftResources?: any[];
  center: { lat: number; lng: number };
  onEventClick: (eventId: string) => void;
  onResourceClick: (resource: any) => void;
}

const DispatchMapPanel: React.FC<DispatchMapPanelProps> = ({
  routes,
  resources,
  onShiftResources = [],
  center,
  onEventClick,
  onResourceClick,
}) => {
  const hasVisibleMapContent = routes.length > 0 || resources.length > 0;
  const onShiftNames = (onShiftResources.length
    ? onShiftResources
    : resources
  )
    .map((resource) => resource?.name || resource?.fullName || resource?.title)
    .filter(Boolean);

  return (
    <div className="h-full flex flex-col">
      <div className="flex-shrink-0 px-4 py-2 border-b border-gray-200 bg-gray-50">
        <h3 className="text-sm font-semibold text-gray-700">Route Map</h3>
      </div>
      <div className="flex-1 overflow-hidden">
        {hasVisibleMapContent ? (
          <MapComponent
            routes={routes}
            resources={resources}
            center={center}
            zoom={7}
            onEventClick={onEventClick}
            onResourceClick={onResourceClick}
          />
        ) : (
          <div className="h-full flex items-center justify-center text-gray-500 px-6 text-center">
            {onShiftNames.length ? (
              <div>
                <p>No live GPS locations to plot.</p>
                <p className="mt-2 text-sm text-gray-600">
                  On shift: {onShiftNames.join(", ")}
                </p>
              </div>
            ) : (
              <p>No routes or active resources to display</p>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default DispatchMapPanel;
